import React, { useRef, useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Helmet } from "react-helmet";
import {
  FiAlertTriangle,
  FiPlusSquare,
  FiTrash2,
  FiFileText,
} from "react-icons/fi";
import FileUpload from "../components/FileUpload";
import { Form } from "@unform/web";
import { Link } from "gatsby";
import Input from "../components/Input";
import InputMask from "../components/InputMask";
import { handleFormSubmit } from "../service/submit";
import { FormHandles } from "@unform/core";
import ModalStatus from "../components/ModalStatus";
import { useLoading, Oval } from "@agney/react-loading";
import { isBrowser } from "../utils/checkBrowser";
import Select from "../components/Select";
import toast, { Toaster } from "react-hot-toast";
import ManyFileUpload from "../components/ManyFileUpload";

const Cadastro: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [agree, setAgree] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [protocolo, setProtocolo] = useState("");
  const [status, setStatus] = useState();
  const [loading, setLoading] = useState(false);

  const [qtdChilds, setQtdChilds] = useState<number[]>([1]);

  const [infoStorage, setInfoStorage] = useState(() => {
    if (isBrowser()) {
      const infoFromStorage = localStorage.getItem("@info-protocol");

      if (infoFromStorage) {
        return JSON.parse(infoFromStorage);
      }

      return null;
    }
  });

  const deleteInfoStorage = () => {
    if (isBrowser() && !!infoStorage) {
      localStorage.removeItem("@info-protocol");
      setInfoStorage(null);
    }
  };

  const { containerProps, indicatorEl } = useLoading({
    loading,
    indicator: <Oval color="#ffffff" style={{ margin: "auto" }} width="75" />,
  });

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "pt-br",
        }}
      >
        <meta charSet="utf-8" />
        <title>Cadastro para solicitação do auxílio cuidar</title>
      </Helmet>

      <Navbar />
      <Toaster
        toastOptions={{ className: "is-danger" }}
        position="bottom-right"
        reverseOrder={false}
      />

      {loading && (
        <div className="bg-loading" {...containerProps}>
          {indicatorEl}
        </div>
      )}
      <div className="container my-6">
        <div className="notification is-info my-6 mx-1">
          <h4 className="is-flex is-align-items-center mb-3">
            <FiAlertTriangle />
            <span className="ml-2">Leia com atenção</span>
          </h4>
          <ol className="list-items">
            <li>
              Todos os campos com asteriscos são de preenchimento obrigatório;
            </li>

            <li>
              Nos campos para inserção dos documentos, anexar todos solicitados,
              conforme descrição no título de cada campo;
            </li>

            <li>
              Não esquecer de clicar no campo ENVIAR para envio do requerimento
              após finalização de seu preenchimento e inserção dos documentos
              obrigatórios;
            </li>

            <li>
              Atentar para o nº do protocolo que será gerado após finalização do
              preenchimento, inserção dos documentos obrigatórios e envio;
            </li>

            <li>
              Guarde com segurança o número de seu protocolo, pois por meio dele
              você poderá acompanhar o status(andamento) de sua solicitação.
            </li>

            <li className="strong">
              <strong>Os documentos anexados devem ser digitalizados e estar com qualidade suficiente para que seja possível realizar a leitura. Evite dobras, rasuras, rasgos ou qualquer outro tipo de dano ao documento. Preferencialmente envie no formato PDF.</strong>
            </li>

          </ol>
        </div>

        {!!infoStorage && (
          <article className="message is-info mx-1">
            <div className="message-header">
              <h5>Último protocolo emitido</h5>
              <button
                className="delete"
                aria-label="delete"
                onClick={deleteInfoStorage}
              ></button>
            </div>
            <div className="message-body">
              O último requerimento feito por este computador, está no nome de{" "}
              <strong>{infoStorage?.name}</strong>. Caso você já tenha está
              informação, clique no botão de fechar, para deletar este aviso.
              Segue o número do protocolo:
              <code className="is-flex is-justify-content-center is-align-items-center is-uppercase is-size-4 has-background-info-light has-text-info mt-5">
                {infoStorage?.protocol}
              </code>
            </div>
          </article>
        )}

        <div className="mx-4 my-6">
          <h3 className="mb-4">Modelos de documentos</h3>

          <div className="columns">
            <a
              href="/modelos/modelo-autodeclaracao.docx"
              target="_blank"
              download
              className="button is-info ml-3 mr-1 my-2"
            >
              <FiFileText className="mr-2" size={20} />
              Modelo de Autodeclaração
            </a>

            <a
              href="/modelos/modelo-relatorio-social.docx"
              target="_blank"
              download
              className="button is-info ml-3 mr-1 my-2"
            >
              <FiFileText className="mr-2" size={20} />
              Relatório Social
            </a>
          </div>
        </div>

        <Form
          ref={formRef}
          onSubmit={(data) => {
            handleFormSubmit(
              formRef,
              data,
              setModalOpen,
              setProtocolo,
              setStatus,
              setLoading,
              toast
            );
          }}
        >
          <div className="mx-4 my-6">
            <h3 className="mb-4">
              Dados do solicitante (responsável legal pelo órfão)
            </h3>

            <div className="columns">
              <div className="column field">
                <Input
                  label="Nome Completo"
                  placeholder="Nome Completo"
                  name="name"
                />
              </div>
              <div className="column field">
                <Input
                  label="RG"
                  placeholder="RG"
                  name="register_id"
                  type="number"
                />
              </div>
              <div className="column field">
                <InputMask
                  label="CPF"
                  placeholder="CPF"
                  mask="999.999.999-99"
                  name="document_id"
                  inputMode="numeric"
                />
              </div>
            </div>

            <div className="columns">
              <div className="column field">
                <Input label="Endereço" placeholder="Endereço" name="address" />
              </div>
              <div className="column field">
                <Input
                  label="Número (Nº)"
                  placeholder="Número (Nº)"
                  name="number"
                  type="number"
                />
              </div>
              <div className="column field">
                <Input
                  label="Bairro/povoado"
                  placeholder="Bairro/povoado"
                  name="neighborhood"
                />
              </div>
            </div>

            <div className="columns">
              <div className="column field">
                <Input
                  label="Cidade/município"
                  placeholder="Cidade/município"
                  name="city"
                />
              </div>
              <div className="column field">
                <Input
                  label="Unidade federativa (Estado)"
                  placeholder="Unidade federativa (Estado)"
                  name="state"
                />
              </div>
              <div className="column field">
                <InputMask
                  label="CEP"
                  mask="99999-999"
                  placeholder="CEP"
                  name="zipcode"
                  inputMode="numeric"
                />
              </div>
            </div>

            <div className="columns">
              <div className="column field">
                <InputMask
                  label="Telefone do cuidador(a), guardião(ã) ou tutor(a)"
                  placeholder="Telefone do cuidador(a), guardião(ã) ou tutor(a)"
                  mask="(99) 99999-9999"
                  name="phone"
                  type="tel"
                  inputMode="numeric"
                />
              </div>
              <div className="column field">
                <Input
                  label="E-mail válido do cuidador(a), guardião(ã) ou tutor(a)"
                  placeholder="E-mail válido do cuidador(a), guardião(ã) ou tutor(a)"
                  name="email"
                  type="email"
                />
              </div>
            </div>
          </div>

          <hr />

          <div className="mx-4 my-6">
            <h3 className="mb-4">
              <span>Dados do beneficiário (órfão)</span>
            </h3>

            {qtdChilds.map((num, i) => (
              <div className="mb-4" key={i}>
                {qtdChilds.length > 1 && (
                  <h5 className="mb-4">
                    {`Beneficiário Nº ${i + 1}`}
                    <button
                      className="button ml-2 is-small is-primary is-rounded"
                      onClick={(e) => {
                        e.preventDefault();

                        const tmpQtdChilds = qtdChilds.filter(
                          (child, index) => index !== i
                        );

                        setQtdChilds(tmpQtdChilds);
                      }}
                    >
                      <FiTrash2 className="mr-1" size={18} />
                      Remover
                    </button>
                  </h5>
                )}
                <div className="columns">
                  <div className="column field">
                    <Input
                      label="Nome da criança/adolescente órfão"
                      placeholder="Nome da criança/adolescente órfão"
                      name={`orphans_name@${i}`}
                    />
                  </div>
                  <div className="column field is-4">
                    <Select
                      label="Sexo da criança/adolescente órfão"
                      placeholder="Sexo da criança/adolescente órfão"
                      name={`orphans_gender@${i}`}
                    />
                  </div>
                </div>

                <div className="columns">
                  <FileUpload
                    classNameCSS="column"
                    label="Certidão de nascimento ou documento oficial que comprove o processo de adoção do órfão"
                    fileLabel="Enviar certidão de nascimento"
                    name={`orphans_birth_certificate@${i}`}
                    type="file"
                  />

                  <div className="column field is-4">
                    <Input
                      label="Data de nascimento da criança/adolescente órfão"
                      placeholder="Data nascimento da criança/adolescente órfão"
                      name={`orphans_birth@${i}`}
                      type="date"
                      lang="pt-br"
                    />
                  </div>
                </div>
              </div>
            ))}

            <button
              className="button is-info"
              onClick={(e) => {
                e.preventDefault();
                setQtdChilds([...qtdChilds, 1]);
              }}
            >
              <FiPlusSquare className="mr-2" size={20} />
              Adicionar outro beneficiário
            </button>

            <hr className="my-6" />

            <h3 className="mb-4">Documentação obrigatória</h3>

            <div className="columns">
              <FileUpload
                classNameCSS="column"
                label="Documento autodeclaratório, com reconhecimento de assinatura em cartório, do cuidador da criança/adolescente órfão, afirmando que assumiu os cuidados e proteção ao órfão até que seja regularizada a guarda, ou documento comprobatório da guarda, tutela ou adoção da criança/ adolescente órfão, se já regularizada legalmente."
                fileLabel="Enviar autodeclaração"
                name="self_declaration"
                type="file"
              />
            </div>

            <div className="columns">
              <FileUpload
                classNameCSS="column"
                label="Certidão de óbito do pai"
                fileLabel="Enviar certidão de óbito"
                name="death_certificate_father"
                type="file"
              />

              <FileUpload
                classNameCSS="column"
                label="Certidão de óbito do mãe"
                fileLabel="Enviar certidão de óbito"
                name="death_certificate_mother"
                type="file"
              />
            </div>

            <div className="columns">
              <FileUpload
                classNameCSS="column"
                label="Certidão emitida pela instituição que gere o regimento de previdência ao qual o/a provedor/a falecido/a era vinculado/a, que ateste que a pensão por morte, devida ao dependente, está abrangida ou não pelas regras constantes no art. 23 da Emenda Constitucional nº 103, de 12 de novembro de 2019."
                fileLabel="Enviar certidão"
                name="social_security_certificate"
                type="file"
              />
            </div>

            <div className="columns">
              <ManyFileUpload
                classNameCSS="column"
                label="Extratos bancários / Contra-cheque / Declaração anual de isenção de IRRF / Número de inscrição social (NIS) - (Inscrição CadÚnico)"
                fileLabel="Enviar Comprovante de Renda"
                name="proof_income"
                type="file"
                multiple={true}
              />
            </div>

            <div className="columns">
              <FileUpload
                classNameCSS="column"
                label="Comprovante de abertura da conta bancária"
                bottomText="Nos casos de criança e/ou adolescente em situação de acolhimento, a conta será poupança em nome da própria criança ou adolescente"
                fileLabel="Enviar documento"
                name="proof_bank_account"
                type="file"
              />

              <FileUpload
                classNameCSS="column"
                label="Comprovante de endereço"
                fileLabel="Enviar comprovante"
                name="proof_address"
                type="file"
              />
            </div>

            <div className="columns is-vcentered">
              <FileUpload
                classNameCSS="column"
                label="Documento identificando o/a coordenador/a ou diretor/a da unidade de acolhimento emitida pelo dirigente da instituição a qual está vinculado"
                bottomText="Somente para os casos de criança e/ou adolescente em situação de acolhimento"
                fileLabel="Enviar documento"
                name="cras_document"
                type="file"
              />

              <FileUpload
                classNameCSS="column"
                label="Relatório social"
                fileLabel="Enviar relatório social"
                name="social_report"
                type="file"
                style={{ paddingBottom: "1.3rem" }}
              />
            </div>
          </div>

          <div className="mx-4 mt-4 pb-6">
            <label className="checkbox mb-4">
              <input
                type="checkbox"
                defaultChecked={agree}
                onChange={(e) => setAgree(Boolean(e.target.checked))}
              />
              <span className="ml-2">
                Declaro-me ciente que a falsidade dessa declaração ou das
                informações nela prestadas configura crimes previstos nós arts.
                297,298 e 299 do Código Penal Brasileiro, passíveis de apuração
                e penalização na forma da lei.
              </span>
            </label>

            <div className="field is-grouped is-flex-wrap-wrap">
              <div className="control mb-2">
                <button
                  type="submit"
                  className={"button is-success is-medium has-text-weight-bold"}
                  disabled={!agree}
                >
                  Enviar documentação
                </button>
              </div>
              <div className="control mb-2">
                <Link
                  to="/"
                  className="button is-primary is-light is-medium has-text-weight-bold"
                >
                  Cancelar
                </Link>
              </div>
            </div>
          </div>
        </Form>

        <ModalStatus
          active={modalOpen}
          setActive={setModalOpen}
          status={status}
          protocolo={protocolo}
        />
      </div>

      <Footer />
    </>
  );
};

export default Cadastro;
